import React from 'react';

export default function HelloReact() {
    return <div>Hello from React 19 🎉</div>;
}
